module.exports = "<h2 md-dialog-title>{{Title}}</h2>\n<div md-dialog-content>{{Message}}</div>\n<div md-dialog-actions>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/material/material-dialog-exist.html
// module id = ../../../../../src/app/pages/material/material-dialog-exist.html
// module chunks = 39